import { useResizeLogic } from '../../../hooks/useResizeLogic';

interface UseForecastResizeProps {
  onWidthChange?: (width: number) => void;
  onResizeChange?: (isResizing: boolean) => void;
}

export function useForecastResize({ onWidthChange, onResizeChange }: UseForecastResizeProps) {
  return useResizeLogic({ onWidthChange, onResizeChange });
}
